import type { Link } from "../types";

const URL_PATTERN = /^https?:\/\//i;

/** URL is stored in entityClass; legacy rows may have the URL in description instead. */
function isLinkUrl(value: string | null | undefined): boolean {
  const trimmed = value?.trim() ?? "";
  return trimmed.length > 0 && URL_PATTERN.test(trimmed);
}

export function resolveLinkUrl(
  link: Pick<Link, "entityClass" | "description">,
): string {
  const entityClass = link.entityClass?.trim() ?? "";
  const description = link.description?.trim() ?? "";

  if (isLinkUrl(entityClass)) return entityClass;
  if (isLinkUrl(description)) return description;
  return "";
}

export function resolveLinkDescription(
  link: Pick<Link, "entityClass" | "description">,
): string {
  const entityClass = link.entityClass?.trim() ?? "";
  const description = link.description?.trim() ?? "";

  const entityIsUrl = isLinkUrl(entityClass);
  const descIsUrl = isLinkUrl(description);

  if (entityIsUrl && !descIsUrl) return description;
  if (descIsUrl && !entityIsUrl) return entityClass;
  if (entityIsUrl && descIsUrl) return "";

  return description || entityClass;
}

/** Normalize API link into edit-form shape (URL in entityClass, text in description). */
export function linkToEditDraft(link: Link): Link {
  const url = resolveLinkUrl(link);
  const description = resolveLinkDescription(link);
  return {
    ...link,
    entityClass: url || null,
    description: description || null,
  };
}
